import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { SpaceService } from './../services/space.service';
import { AuthService } from './../services/auth.service';
@Component({
  selector: 'app-member',
  templateUrl: './member.component.html',
  styleUrls: ['./member.component.scss']
})
export class MemberComponent implements OnInit {
  companyData: any;
  selectedCompany: any;

  constructor(
    private route: ActivatedRoute,
    private spaceService: SpaceService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.route.data.subscribe(({company}) => {
      this.companyData = company.data ? company.data : [];
      const selectedCompanyId = this.authService.getCompanyId();
      this.companyData = _.map(this.companyData,  (item, index) => {
        if (selectedCompanyId !== '' && selectedCompanyId === item.company_id) {
          // Setting roles and company id for the first time
          this.authService.setCompanyId(item.company_id);
          this.authService.setCompanyRoles(item.role);
          this.authService.setInvoiceAccess(item.invoice_permission);
          this.authService.setBillingAccess(item.billing_permission);
          item.selected = true;
        } else if (selectedCompanyId === '' && index === 0) {
          // Setting roles and company id for the first time
          this.authService.setCompanyId(item.company_id);
          this.authService.setCompanyRoles(item.role);
          this.authService.setInvoiceAccess(item.invoice_permission);
          this.authService.setBillingAccess(item.billing_permission);
          item.selected = true;
        } else {
          item.selected = false;
        }
        return item;
      });
      this.spaceService.setCompanyData(this.companyData);
    });
  }

}
